// extracted by mini-css-extract-plugin
module.exports = {"loader":"Va","smallLoader":"Wa","loading-keyframes":"Xa","pageLoader":"Ya","centered":"Za","whitespacePlaceholder":"_a","buttonSpinner":"ab","fade-in":"bb","rotate":"cb"};